import fetch from '../fetch'
import {
  AttachmentParamsType,
  AttachmentRespType,
  AttachmentType,
  CaseReportId,
  PartType,
} from '../../models/caseReport'
import { AxiosResponse } from 'axios'

/** Hlavička Attachments Service */
export interface AttachmentsService {
  uploadAttachment: ({
    caseReportId,
    partType,
    attachmentType,
    file,
    itemOrderNum,
  }: DoUploadAttachmentParamsType) => Promise<AttachmentRespType>

  deleteAttachment: ({
    caseReportId,
    attachmentId,
  }: {
    caseReportId: CaseReportId
    attachmentId: string
  }) => Promise<void>
}

// TOTO chci pouzivat z formularu - odesila se 'File'
export type DoUploadAttachmentParamsType = {
  caseReportId: CaseReportId
  partType: PartType
  attachmentType: AttachmentType
  file: File
  itemOrderNum: number | undefined | null
}

// PUVODNI / VYSLEDEK REFAKTORINGU CISLO 1
type UploadAttachmentParamsType = AttachmentParamsType & {
  caseReportId: string
  file: FormData // FormData - budto s Filem, nebo s Blobem (generovane PDF)
}

// AttachmentsServiceImpl
export class AttachmentsServiceImpl implements AttachmentsService {
  // IMPL OF doUploadAttachment that sends call to API
  public async uploadAttachment({
    caseReportId,
    partType,
    attachmentType,
    file,
    itemOrderNum,
  }: DoUploadAttachmentParamsType): Promise<AttachmentRespType> {
    const fileName: string = file.name
    const formData = new FormData()
    formData.append('document', file)
    try {
      const uploadParams: UploadAttachmentParamsType = {
        // UploadAttachmentParamsType
        caseReportId: caseReportId,
        part: partType,
        type: attachmentType,
        itemOrderNum: itemOrderNum ?? 1, // if item order num is not specified, it should be sent as '1' to the rest-api
        fileName: fileName,
        file: formData,
      }

      const res: AxiosResponse<any> = await this.uploadAttachment0(uploadParams)
      const uploadResp: any = res!.data
      if (!uploadResp.attachmentId) {
        throw new Error('POST attachment did not return attachmentId !')
      }

      const newAttachment: AttachmentRespType = {
        attachmentId: uploadResp.attachmentId,
        fileName: uploadParams.fileName, // server by to mel asi odeslat zpet, ale nevadi, info mame :)
      }
      return newAttachment
    } catch (error) {
      // Error uploadu dokumentu. Co nyni delat?
      //console.log(error)
      throw error
    }
  }

  // VNITRNI IMPLEMENTACE
  // PUVODNI / VYSLEDEK REFAKTORINGU CISLO 1

  // IMPL OF doUploadAttachment that sends call to API
  private uploadAttachment0(
    uploadAttachmentParams: UploadAttachmentParamsType
  ): Promise<AxiosResponse<any>> {
    const token = localStorage.getItem('token')
    let queryParams: AttachmentParamsType = {
      // XXX posilame fileName 2x?
      part: uploadAttachmentParams.part,
      type: uploadAttachmentParams.type,
      itemOrderNum: uploadAttachmentParams.itemOrderNum,
      fileName: uploadAttachmentParams.fileName,
    }

    return fetch({
      method: 'POST',
      path: `api/v1/case-report/${uploadAttachmentParams.caseReportId}/attachment`,
      headers: {
        Authorization: token && `Bearer ${token}`,
      },
      params: queryParams,
      data: uploadAttachmentParams.file,
    })
  }

  // IMPL OF doUploadAttachment that sends call to API
  public async deleteAttachment({
    caseReportId,
    attachmentId,
  }: {
    caseReportId: CaseReportId
    attachmentId: string
  }): Promise<void> {
    const token = localStorage.getItem('token')
    if (token == null) {
      throw new Error('No auth token')
    }
    try {
      await this.deleteAttachment0({
        token: token,
        caseReportId: caseReportId,
        attachmentId: attachmentId,
      })
    } catch (error) {
      // Error uploadu dokumentu. Co nyni delat?
      //console.log(error)
      throw error
    }
  }

  private deleteAttachment0({
    token,
    caseReportId,
    attachmentId,
  }: {
    token: string
    caseReportId: CaseReportId
    attachmentId: string
  }): Promise<AxiosResponse<any>> {
    return fetch({
      method: 'DELETE',
      path: `api/v1/case-report/${caseReportId}/attachment/${attachmentId}`,
      headers: {
        Authorization: token && `Bearer ${token}`,
      },
    })
  }
}

// AttachmentsServiceFake
export class AttachmentsServiceFake implements AttachmentsService {
  // IMPL OF doUploadAttachment that sends call to API
  public async uploadAttachment({
    caseReportId,
    partType,
    attachmentType,
    file,
    itemOrderNum,
  }: DoUploadAttachmentParamsType): Promise<AttachmentRespType> {
    await this.delay(2000)
    const newAttachment: AttachmentRespType = {
      attachmentId: '123',
      fileName: file.name,
    }
    return newAttachment
  }

  // IMPL OF doUploadAttachment that sends call to API
  public async deleteAttachment({
    caseReportId,
    attachmentId,
  }: {
    caseReportId: CaseReportId
    attachmentId: string
  }): Promise<void> {
    await this.delay(2000)
  }

  private delay(millis: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, millis))
  }
}
